module.exports = __webpack_public_path__ + "img/placket width.9688e5f6.png";